var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C23.2852 0 30 6.71484 30 15C30 23.2852 23.2852 30 15 30C6.71484 30 0 23.2852 0 15C0 6.71484 6.71484 0 15 0Z",
    fill: "url(#paint0_radial_52_3672)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5332 11.584C12.5508 8.63672 17.4492 8.63672 20.4668 11.584L20.8301 11.9414C20.9824 12.0879 20.9824 12.3281 20.8301 12.4746L19.5879 13.6875C19.5117 13.7637 19.3887 13.7637 19.3125 13.6875L18.8145 13.2012C16.7051 11.1445 13.2949 11.1445 11.1855 13.2012L10.6523 13.7227C10.5762 13.7988 10.4531 13.7988 10.377 13.7227L9.13477 12.5098C8.98242 12.3633 8.98242 12.123 9.13477 11.9766L9.5332 11.584ZM23.0391 14.0918L24.1465 15.1699C24.2988 15.3164 24.2988 15.5566 24.1465 15.7031L19.1602 20.5723C19.0078 20.7188 18.7617 20.7188 18.6152 20.5723L15.0762 17.1152C15.041 17.0801 14.9766 17.0801 14.9414 17.1152L11.4023 20.5723C11.25 20.7188 11.0039 20.7188 10.8574 20.5723L5.85352 15.7031C5.70117 15.5566 5.70117 15.3164 5.85352 15.1699L6.96094 14.0918C7.11328 13.9453 7.35938 13.9453 7.50586 14.0918L11.0449 17.5488C11.0801 17.584 11.1445 17.584 11.1797 17.5488L14.7188 14.0918C14.8711 13.9453 15.1172 13.9453 15.2637 14.0918L18.8027 17.5488C18.8379 17.584 18.9023 17.584 18.9375 17.5488L22.4766 14.0918C22.6406 13.9453 22.8867 13.9453 23.0391 14.0918Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_52_3672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.29832e-05 15.0005) scale(30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.335130afe82f99edfb0dd352935afbd4.svg";
export { ForwardRef as ReactComponent };